module.exports = __webpack_public_path__ + "static/media/namen.e0416769.jpg";